import { Grid, Radio, Typography } from '@mui/material';
import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { ReactNode } from 'react';

export interface ItemSelectionCellProps<R extends GridValidRowModel = any> {
  label: ReactNode;
  bold?: boolean;
  row?: R;
  checked: boolean;
  onToggle: () => void;
  viewOnly?: boolean;
  radioStart?: ReactNode;
}

export const ItemSelectionCell = <R extends GridValidRowModel = any>({
  label,
  bold,
  checked,
  onToggle,
  radioStart,
}: ItemSelectionCellProps<R>) => {
  return (
    <Grid container spacing={2} size={16} alignItems="center" maxWidth="100%">
      <Grid size="grow" onClick={onToggle} style={{ cursor: 'pointer' }} alignItems="center" display="flex">
        {bold ? (
          <Typography variant="body2" fontWeight="bold">
            {label}
          </Typography>
        ) : (
          label
        )}
      </Grid>
      <Grid textAlign="right">
        {radioStart}
        <Radio size="small" checked={checked} onClick={onToggle} />
      </Grid>
    </Grid>
  );
};
